export const infrastructure = {
  'bhaktapur': {
    'school': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4235529890",
          "properties": {
            "amenity": "school",
            "email": "seducon@hotmail.com",
            "name": "SEDUCON Pvt. Ltd. ",
            "phone": "+97716617093",
            "website": "https://seducon.webs.com/",
            "id": "node/4235529890"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4216874,
              27.6729718
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4550354490",
          "properties": {
            "addr:postcode": "44800",
            "addr:street": "Adarsha",
            "amenity": "school",
            "email": "info@vhsbhaktapur.org",
            "name:en": "VHS Bhaktapur",
            "opening_hours": "Mo-Fr 06:00-18:00",
            "phone": "016611283",
            "website": "http://www.vhsbhaktapur.org",
            "id": "node/4550354490"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4328767,
              27.6678538
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4565333189",
          "properties": {
            "addr:postcode": "44800",
            "amenity": "school",
            "name:en": "Khwopa College of Engineering",
            "operator": "Bhaktapur Municipality",
            "id": "node/4565333189"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4390675,
              27.6707947
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4565345589",
          "properties": {
            "addr:postcode": "44800",
            "amenity": "school",
            "name:en": "Bal Vikash Secondary School",
            "phone": "+9775122333",
            "id": "node/4565345589"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4422666,
              27.6705503
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5498199126",
          "properties": {
            "amenity": "school",
            "name": "बासु माध्यमिक विद्यालय (Basu secondary school)",
            "name:en": "बासु माध्यमिक विद्यालय (Basu secondary school)",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/5498199126"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4292246,
              27.6783129
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5498199127",
          "properties": {
            "addr:street": "chyamasingh",
            "amenity": "school",
            "email": "infobagisworischool@gmail.com",
            "name": "Bagiswori Secondary School",
            "name:en": "बागीश्वरी माध्यमिक विद्यालय (Bagiswori Secondary School)",
            "phone": "6610270",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/5498199127"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4387743,
              27.6730703
            ]
          }
        }
      ]
    },
    'bank': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4235529890",
          "properties": {
            "amenity": "school",
            "email": "seducon@hotmail.com",
            "name": "SEDUCON Pvt. Ltd. ",
            "phone": "+97716617093",
            "website": "https://seducon.webs.com/",
            "id": "node/4235529890"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4216874,
              27.6729718
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4550354490",
          "properties": {
            "addr:postcode": "44800",
            "addr:street": "Adarsha",
            "amenity": "school",
            "email": "info@vhsbhaktapur.org",
            "name:en": "VHS Bhaktapur",
            "opening_hours": "Mo-Fr 06:00-18:00",
            "phone": "016611283",
            "website": "http://www.vhsbhaktapur.org",
            "id": "node/4550354490"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4328767,
              27.6678538
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4565333189",
          "properties": {
            "addr:postcode": "44800",
            "amenity": "school",
            "name:en": "Khwopa College of Engineering",
            "operator": "Bhaktapur Municipality",
            "id": "node/4565333189"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4390675,
              27.6707947
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4565345589",
          "properties": {
            "addr:postcode": "44800",
            "amenity": "school",
            "name:en": "Bal Vikash Secondary School",
            "phone": "+9775122333",
            "id": "node/4565345589"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4422666,
              27.6705503
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5498199126",
          "properties": {
            "amenity": "school",
            "name": "बासु माध्यमिक विद्यालय (Basu secondary school)",
            "name:en": "बासु माध्यमिक विद्यालय (Basu secondary school)",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/5498199126"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4292246,
              27.6783129
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5498199127",
          "properties": {
            "addr:street": "chyamasingh",
            "amenity": "school",
            "email": "infobagisworischool@gmail.com",
            "name": "Bagiswori Secondary School",
            "name:en": "बागीश्वरी माध्यमिक विद्यालय (Bagiswori Secondary School)",
            "phone": "6610270",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/5498199127"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4387743,
              27.6730703
            ]
          }
        }
      ]
    },
    'hospital': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4225138790",
          "properties": {
            "addr:postcode": "44800",
            "addr:street": "Dudhpati",
            "amenity": "hospital",
            "name": "Bhaktapur Hospital Emergency Block",
            "id": "node/4225138790"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4220862,
              27.6720774
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4356785907",
          "properties": {
            "amenity": "hospital",
            "location": "bhaktapur",
            "name": "Sahara Herchaha Kendra",
            "operator": "private",
            "id": "node/4356785907"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4037681,
              27.6744263
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065482890",
          "properties": {
            "amenity": "hospital",
            "healthcare": "hospital",
            "name": "District community Eye center",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/6065482890"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.438899,
              27.6745463
            ]
          }
        }
      ]
    },
    'government': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4356792494",
          "properties": {
            "addr:street": "byasi",
            "name": "District Education Office, Bhaktapur",
            "office": "government",
            "id": "node/4356792494"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4267367,
              27.6789423
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4513012289",
          "properties": {
            "addr:housenumber": "2",
            "addr:street": "tumacho-barmayani",
            "name:en": "Bhaktapur malpot",
            "office": "government",
            "opening_hours": "Su-Fr",
            "id": "node/4513012289"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4412507,
              27.6755072
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4826551022",
          "properties": {
            "name:en": "Department of Transport Management (Renewal)",
            "office": "government",
            "id": "node/4826551022"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4052183,
              27.6738497
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4870116021",
          "properties": {
            "name:en": "Municipality ward No.2",
            "office": "government",
            "id": "node/4870116021"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4278033,
              27.6745799
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5970742485",
          "properties": {
            "name:en": "DLPIU(District Level Project Implementation Unit)",
            "office": "government",
            "id": "node/5970742485"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4137285,
              27.6757489
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6002015507",
          "properties": {
            "name:en": "Tourist checkpoint - ticket counter",
            "office": "government",
            "id": "node/6002015507"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4318433,
              27.6751581
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6002015511",
          "properties": {
            "name:en": "Tourist Checkpoint - Ticket booth",
            "office": "government",
            "id": "node/6002015511"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4369313,
              27.6760062
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6002015512",
          "properties": {
            "name:en": "Tourist Checkpoint - ticket shop",
            "office": "government",
            "id": "node/6002015512"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4382963,
              27.6733962
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6002015513",
          "properties": {
            "name:en": "Tourist checkpoint - ticket shop",
            "office": "government",
            "id": "node/6002015513"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4242957,
              27.6677302
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6002021099",
          "properties": {
            "name:en": "Tourist checkpoint - ticket office",
            "office": "government",
            "id": "node/6002021099"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4231418,
              27.6715403
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6005408085",
          "properties": {
            "name:en": "Tourist ticket checkpoint",
            "office": "government",
            "id": "node/6005408085"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4317702,
              27.6681389
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065309106",
          "properties": {
            "name": "Bhumishudar Office Bhaktapur Bashi",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/6065309106"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4289437,
              27.6745111
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065309107",
          "properties": {
            "name": "Distance Education Office",
            "office": "government",
            "toilets:wheelchair": "limited",
            "wheelchair": "no",
            "id": "node/6065309107"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4272936,
              27.674928
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065309108",
          "properties": {
            "name": "District Administration Office (CDO)-Bhaktapur",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/6065309108"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4277341,
              27.6741218
            ]
          }
        }
      ]
    },
    'touristic_religious': {
  "type": "FeatureCollection",
  "generator": "overpass-ide",
  "copyright": "The data included in this document is from www.openstreetmap.org. The data is made available under ODbL.",
  "timestamp": "2021-01-11T04:23:03Z",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990801562",
        "amenity": "place_of_worship",
        "name": "Ganesh Shrine",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278033,
          27.6701015
        ]
      },
      "id": "node/990801562"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990902873",
        "name": "Brass and Bronze Museum",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4355371,
          27.6736291
        ]
      },
      "id": "node/990902873"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990902874",
        "name": "Woodcarving Museum",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4355279,
          27.6733873
        ]
      },
      "id": "node/990902874"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990902931",
        "name": "National Art Gallery",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4284483,
          27.6722798
        ]
      },
      "id": "node/990902931"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1894365457",
        "amenity": "place_of_worship",
        "name": "Indrayani",
        "religion": "hindu",
        "wheelchair": "limited"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4268439,
          27.6731574
        ]
      },
      "id": "node/1894365457"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1945526769",
        "amenity": "place_of_worship",
        "name": "Chonga Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4110065,
          27.674308
        ]
      },
      "id": "node/1945526769"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1964172915",
        "amenity": "place_of_worship",
        "name": "Dahi Binayak",
        "religion": "hindu",
        "wheelchair": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4305049,
          27.6720589
        ]
      },
      "id": "node/1964172915"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1964172925",
        "amenity": "place_of_worship",
        "name": "Tripursundari Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4304269,
          27.6727276
        ]
      },
      "id": "node/1964172925"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1990747005",
        "addr:city": "chochhen",
        "addr:tole": "chochhen",
        "amenity": "place_of_worship",
        "facility": "temple",
        "name": "Chhuma Ganesh Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4305836,
          27.6745426
        ]
      },
      "id": "node/1990747005"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2012066696",
        "amenity": "place_of_worship",
        "religion": "muslim"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4334196,
          27.6698129
        ]
      },
      "id": "node/2012066696"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2060240290",
        "amenity": "place_of_worship",
        "historic": "monument",
        "name": "Statue of Sleeping Narayan",
        "religion": "hindu",
        "tourism": "attraction"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4312982,
          27.6765998
        ]
      },
      "id": "node/2060240290"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2200289761",
        "amenity": "place_of_worship",
        "name": "Temple of Bhairav",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4282429,
          27.6708065
        ]
      },
      "id": "node/2200289761"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2203472846",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4290432,
          27.670558
        ]
      },
      "id": "node/2203472846"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2272638927",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4331767,
          27.6749065
        ]
      },
      "id": "node/2272638927"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2291356298",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4262151,
          27.6707195
        ]
      },
      "id": "node/2291356298"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2291360341",
        "amenity": "place_of_worship",
        "name": "Mulakhu Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4268002,
          27.6704947
        ]
      },
      "id": "node/2291360341"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2337286049",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4291961,
          27.6707605
        ]
      },
      "id": "node/2337286049"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2406617432",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4299323,
          27.6736263
        ]
      },
      "id": "node/2406617432"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2444734531",
        "amenity": "place_of_worship",
        "name": "Vatsala"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4288306,
          27.6723189
        ]
      },
      "id": "node/2444734531"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2449083911",
        "amenity": "place_of_worship",
        "name": "Dhumawati",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4303899,
          27.6718964
        ]
      },
      "id": "node/2449083911"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477469722",
        "addr:housename": "Near Chuping Ghat",
        "amenity": "place_of_worship",
        "denomination": "hindu",
        "name": "Narayan Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4299825,
          27.6683668
        ]
      },
      "id": "node/2477469722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477469723",
        "addr:housename": "side of chuping ghat",
        "amenity": "place_of_worship",
        "name": "Shiva Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301073,
          27.6682836
        ]
      },
      "id": "node/2477469723"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477513503",
        "amenity": "place_of_worship",
        "name": "Shiva Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4297117,
          27.6661251
        ]
      },
      "id": "node/2477513503"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477516924",
        "amenity": "place_of_worship",
        "fixme": "What means number of blocks = 3?",
        "name": "Nasdyo",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301422,
          27.6692438
        ]
      },
      "id": "node/2477516924"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477565495",
        "addr:housename": "Bhaktapur-12",
        "amenity": "place_of_worship",
        "name": "Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4349769,
          27.6683445
        ]
      },
      "id": "node/2477565495"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477566459",
        "addr:housename": "Bhaktapur-12",
        "amenity": "place_of_worship",
        "name": "Saraswati Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4312207,
          27.6685214
        ]
      },
      "id": "node/2477566459"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477572130",
        "addr:housename": "Bhuichalo (earthquake) temple",
        "amenity": "place_of_worship",
        "name": "Bhuichalo (earthquake) temple",
        "name:en": "भिसिं द्यः",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4313179,
          27.668506
        ]
      },
      "id": "node/2477572130"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477603263",
        "amenity": "place_of_worship",
        "name": "Temple",
        "name:fr": "Temple de Jeth Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4277593,
          27.6698375
        ]
      },
      "id": "node/2477603263"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2477913780",
        "amenity": "place_of_worship",
        "name": "Shrine to Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.425559,
          27.6664661
        ]
      },
      "id": "node/2477913780"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478783702",
        "amenity": "place_of_worship",
        "denomination": "Nepalies",
        "name": "Ganesh Mandhir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4286595,
          27.6698202
        ]
      },
      "id": "node/2478783702"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2609003247",
        "amenity": "place_of_worship",
        "name": "Balakhu ganesh temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4293774,
          27.6726473
        ]
      },
      "id": "node/2609003247"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3493526205",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4359238,
          27.6748679
        ]
      },
      "id": "node/3493526205"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3493526835",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4363324,
          27.6747042
        ]
      },
      "id": "node/3493526835"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3493526953",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4366943,
          27.6745212
        ]
      },
      "id": "node/3493526953"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3678942236",
        "addr:street": "itachhen",
        "amenity": "place_of_worship",
        "name": "Lokeswor",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4255992,
          27.672121
        ]
      },
      "id": "node/3678942236"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4278670646",
        "addr:street": "tinachhen",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4354447,
          27.6747549
        ]
      },
      "id": "node/4278670646"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4314051225",
        "amenity": "place_of_worship",
        "name": "Balkumari temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4374267,
          27.6743645
        ]
      },
      "id": "node/4314051225"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4314057248",
        "amenity": "place_of_worship",
        "name": "Ganesh Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4373087,
          27.6740469
        ]
      },
      "id": "node/4314057248"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4329256591",
        "amenity": "place_of_worship",
        "name": "Degaina Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4412005,
          27.6737189
        ]
      },
      "id": "node/4329256591"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4380964290",
        "addr:street": "Napookhu",
        "amenity": "place_of_worship",
        "name": "Thathu Bahi",
        "name:en": "Thathu Bahi",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4227956,
          27.6728095
        ]
      },
      "id": "node/4380964290"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4413342541",
        "amenity": "place_of_worship",
        "name": "Temple",
        "name:fr": "Temple de Vishnu",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278531,
          27.6698786
        ]
      },
      "id": "node/4413342541"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4513012589",
        "amenity": "place_of_worship",
        "name:en": "Shiv lig"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.437826,
          27.6744175
        ]
      },
      "id": "node/4513012589"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4692191194",
        "amenity": "place_of_worship",
        "name:en": "Kingdom hall of Jehovha's Witnesses"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4117544,
          27.6703836
        ]
      },
      "id": "node/4692191194"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4773049821",
        "addr:city": "bhaktapur municipality",
        "addr:place": "libali-8",
        "addr:street": "bagiswori school to khwopa engineering college",
        "amenity": "place_of_worship",
        "email": "you3kesh@gmail.com",
        "name:en": "गणेश मन्दिर",
        "phone": "9849127957"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4393767,
          27.6724165
        ]
      },
      "id": "node/4773049821"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002664276",
        "addr:city": "bhaktapur municipality",
        "addr:place": "wachu tole",
        "amenity": "place_of_worship",
        "name": "Narayan temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4348949,
          27.6721381
        ]
      },
      "id": "node/5002664276"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002675944",
        "addr:city": "bhaktapur municipality",
        "addr:place": "jela-8",
        "amenity": "place_of_worship",
        "name": "Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4357171,
          27.6725899
        ]
      },
      "id": "node/5002675944"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002682724",
        "addr:city": "bhaktapur municipality",
        "addr:place": "jela-8",
        "amenity": "place_of_worship",
        "name": "Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4357076,
          27.6726992
        ]
      },
      "id": "node/5002682724"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5002685857",
        "addr:city": "bhaktapur municipality",
        "addr:place": "jela-8",
        "amenity": "place_of_worship",
        "name": "Macho Bhairab"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4358727,
          27.6719461
        ]
      },
      "id": "node/5002685857"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5325557268",
        "amenity": "place_of_worship",
        "name:en": "Ni Bahal"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.425444,
          27.6711925
        ]
      },
      "id": "node/5325557268"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5325557357",
        "amenity": "place_of_worship",
        "name:en": "Sri Indravarta Mahavihar"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4342149,
          27.6720953
        ]
      },
      "id": "node/5325557357"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5360373222",
        "addr:postcode": "977",
        "addr:street": "Byasi",
        "amenity": "place_of_worship",
        "name:en": "Krishp Dai Basne Ghar",
        "phone": "9843041030"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4287651,
          27.6751057
        ]
      },
      "id": "node/5360373222"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5498199028",
        "amenity": "place_of_worship",
        "name": "छोलेश्वर महाद्यं"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295267,
          27.6788428
        ]
      },
      "id": "node/5498199028"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5498199128",
        "amenity": "place_of_worship",
        "name:en": "ब्रम्हायणी द्याेछें"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4367249,
          27.673634
        ]
      },
      "id": "node/5498199128"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5555550776",
        "amenity": "place_of_worship",
        "name": "Mul Dipankar Bihar"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.434266,
          27.6750772
        ]
      },
      "id": "node/5555550776"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5828845485",
        "amenity": "place_of_worship",
        "name:en": "Ishaneshwor Mahadev Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.404389,
          27.6739721
        ]
      },
      "id": "node/5828845485"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6065420348",
        "name": "National Art Museum",
        "toilets:wheelchair": "no",
        "tourism": "museum",
        "wheelchair": "limited"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4288879,
          27.6725543
        ]
      },
      "id": "node/6065420348"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6065420349",
        "amenity": "place_of_worship",
        "name": "Nyatapola temple",
        "religion": "hindu",
        "toilets:wheelchair": "no",
        "wheelchair": "yes"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295166,
          27.6714788
        ]
      },
      "id": "node/6065420349"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6547050125",
        "addr:city": "bhaktapur municipality",
        "amenity": "place_of_worship",
        "name": "Maheshori Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4358933,
          27.6706824
        ]
      },
      "id": "node/6547050125"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6694350159",
        "amenity": "place_of_worship",
        "name": "Gorakhnath Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4277972,
          27.6702168
        ]
      },
      "id": "node/6694350159"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7175527186",
        "addr:street": "byasi",
        "amenity": "place_of_worship",
        "name:en": "Mahakali"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4311223,
          27.6759675
        ]
      },
      "id": "node/7175527186"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7176386288",
        "amenity": "place_of_worship",
        "name:en": "Laghu ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295464,
          27.6746951
        ]
      },
      "id": "node/7176386288"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7176386289",
        "amenity": "place_of_worship",
        "name:en": "Narayan dyocha"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4296085,
          27.6746474
        ]
      },
      "id": "node/7176386289"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7176398386",
        "amenity": "place_of_worship",
        "name:en": "Ram sita temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4295617,
          27.6746478
        ]
      },
      "id": "node/7176398386"
    }
  ]
}
  },
  'changunarayan': {
    'school': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/1489545888",
          "properties": {
            "amenity": "school",
            "name": "Shree Mahankali Secondary School",
            "id": "node/1489545888"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.5211945,
              27.7201366
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/2513634073",
          "properties": {
            "amenity": "school",
            "name": "Manohara Secondary School",
            "operator": "Nepal Government",
            "id": "node/2513634073"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4095133,
              27.7056732
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4324876877",
          "properties": {
            "amenity": "school",
            "name": "Nepal Army School",
            "id": "node/4324876877"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.5190864,
              27.7082422
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4324888421",
          "properties": {
            "amenity": "school",
            "name": "Shree Kalika Secondary School",
            "id": "node/4324888421"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4873336,
              27.7108191
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5153025022",
          "properties": {
            "amenity": "school",
            "name:en": "Saraswoti Secondary School",
            "id": "node/5153025022"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4908454,
              27.6910272
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5479582621",
          "properties": {
            "addr:housenumber": "11",
            "addr:postcode": "12345",
            "addr:street": "BHAKTAPUR NALA ROAD(GANESHMAN MARGA)",
            "amenity": "school",
            "name:en": "Aarakshan national school",
            "opening_hours": "Su-Fr 00:00-24:00",
            "phone": "9841243750",
            "id": "node/5479582621"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.477628,
              27.6788266
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5479582622",
          "properties": {
            "addr:housenumber": "11",
            "addr:postcode": "1234",
            "addr:street": "sudal bus park",
            "amenity": "school",
            "name:en": "Aarakshan national school",
            "opening_hours": "Su-Fr 00:00-24:00",
            "phone": "9841243750",
            "id": "node/5479582622"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4776936,
              27.6787758
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6497936382",
          "properties": {
            "amenity": "school",
            "name": "Dolgiri Higher Secondary school",
            "id": "node/6497936382"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4268248,
              27.7156841
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6499238747",
          "properties": {
            "amenity": "school",
            "name": "Champak Vidyapith",
            "id": "node/6499238747"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.430116,
              27.7170348
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6499238748",
          "properties": {
            "amenity": "school",
            "name": "Champak Vidyapith",
            "id": "node/6499238748"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4298666,
              27.7172746
            ]
          }
        }
      ]
    },
    'bank': {
      "type": "FeatureCollection",
      "features": [{
        "type": "Feature",
        "id": "node/4470655791",
        "properties": {
          "amenity": "bank",
          "name:en": "NUBL Chaling Sakha",
          "id": "node/4470655791"
        },
        "geometry": {
          "type": "Point",
          "coordinates": [
            85.4705689,
            27.7037567
          ]
        }
      }]
    },
    'hospital': {
      "type": "FeatureCollection",
      "features": []
    },
    'government': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4243040930",
          "properties": {
            "name": "VDC Office,12,13,14,15,16",
            "office": "government",
            "id": "node/4243040930"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4152053,
              27.6926811
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4560164502",
          "properties": {
            "name:en": "Nagarkot Municipality Office",
            "office": "government",
            "id": "node/4560164502"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4489785,
              27.6819684
            ]
          }
        }
      ]
    },
    'touristic_religious': {
  "type": "FeatureCollection",
  "generator": "overpass-ide",
  "copyright": "The data included in this document is from www.openstreetmap.org. The data is made available under ODbL.",
  "timestamp": "2021-01-11T04:20:02Z",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969476986",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4298676,
          27.6818997
        ]
      },
      "id": "node/1969476986"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969477067",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4300727,
          27.6891765
        ]
      },
      "id": "node/1969477067"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969477070",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301685,
          27.6896236
        ]
      },
      "id": "node/1969477070"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1969477094",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4298604,
          27.690739
        ]
      },
      "id": "node/1969477094"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2076576713",
        "amenity": "place_of_worship",
        "name": "Yatu Mahadev Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4484526,
          27.682419
        ]
      },
      "id": "node/2076576713"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2152942986",
        "amenity": "place_of_worship",
        "name": "Saraswati temple",
        "opening_hours": "06:00-00:00",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4160466,
          27.7095167
        ]
      },
      "id": "node/2152942986"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2272327532",
        "amenity": "place_of_worship",
        "name": "yapi bhairab",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4205463,
          27.6988529
        ]
      },
      "id": "node/2272327532"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2279168972",
        "amenity": "place_of_worship",
        "name": "kotdevi",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4323012,
          27.6960101
        ]
      },
      "id": "node/2279168972"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2299787966",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4612551,
          27.7036906
        ]
      },
      "id": "node/2299787966"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2302656481",
        "amenity": "place_of_worship",
        "name": "Chaturbahu Narayan",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4156739,
          27.701117
        ]
      },
      "id": "node/2302656481"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478690286",
        "Type": "Covered by iron gatte and temple between water pond",
        "amenity": "place_of_worship",
        "name": "Shree sheshnarayan temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4309071,
          27.6933565
        ]
      },
      "id": "node/2478690286"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478693248",
        "amenity": "place_of_worship",
        "name": "Ram Janaki temple",
        "religion": "hindu",
        "type": "3 blocks"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4310224,
          27.6933256
        ]
      },
      "id": "node/2478693248"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478760289",
        "amenity": "place_of_worship",
        "name": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4301852,
          27.6896695
        ]
      },
      "id": "node/2478760289"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478779117",
        "amenity": "place_of_worship",
        "name": "Ganesh Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4223897,
          27.6851278
        ]
      },
      "id": "node/2478779117"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478794557",
        "amenity": "place_of_worship",
        "name": "ganesh mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4303062,
          27.6862256
        ]
      },
      "id": "node/2478794557"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2478804460",
        "amenity": "place_of_worship",
        "name": "Chhinamasta Durga Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4216472,
          27.6884893
        ]
      },
      "id": "node/2478804460"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324787247",
        "amenity": "place_of_worship",
        "name": "Paanchmukhi Hanuman temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4543185,
          27.7106661
        ]
      },
      "id": "node/4324787247"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324794311",
        "amenity": "place_of_worship",
        "name": "Jalapadevi Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4777181,
          27.7102292
        ]
      },
      "id": "node/4324794311"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324799335",
        "amenity": "place_of_worship",
        "name": "Small white gomba",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4905605,
          27.7125468
        ]
      },
      "id": "node/4324799335"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4324892087",
        "amenity": "place_of_worship",
        "name": "Kaali Devi Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.453662,
          27.7109207
        ]
      },
      "id": "node/4324892087"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4375884789",
        "addr:street": "Telcot-Changu Road",
        "amenity": "place_of_worship",
        "name:en": "panchamaha Laxmi Temple",
        "opening_hours": "24/7"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4721753,
          27.7167306
        ]
      },
      "id": "node/4375884789"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4394565690",
        "amenity": "place_of_worship",
        "name:en": "Shree Radha Krishna Temple",
        "name:hi": "श्री राधाकृष्ण मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4654596,
          27.6968922
        ]
      },
      "id": "node/4394565690"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4395911590",
        "amenity": "place_of_worship",
        "name:en": "Muhan Ganesh Temple",
        "name:hi": "मुहान गणेश मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4827612,
          27.7047993
        ]
      },
      "id": "node/4395911590"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4396988690",
        "amenity": "place_of_worship",
        "name:en": "Panchamukhi Hanuman Temple",
        "name:hi": "पँन्चमुखी हनुमान मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4534263,
          27.7107045
        ]
      },
      "id": "node/4396988690"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4396994889",
        "amenity": "place_of_worship",
        "name:en": "Bagehiti Temple",
        "name:hi": "बागेहिटी मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4840471,
          27.6995939
        ]
      },
      "id": "node/4396994889"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4506496796",
        "amenity": "place_of_worship",
        "name:en": "Shree Radha Krishna Mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4702841,
          27.7024363
        ]
      },
      "id": "node/4506496796"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4506511892",
        "amenity": "place_of_worship",
        "name:en": "Bhimsenthan"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4803671,
          27.6994111
        ]
      },
      "id": "node/4506511892"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4533218789",
        "amenity": "place_of_worship",
        "name:en": "om shanti mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4751913,
          27.6863416
        ]
      },
      "id": "node/4533218789"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4560171195",
        "amenity": "place_of_worship",
        "name:en": "Shree Manakamana Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4614571,
          27.7073442
        ]
      },
      "id": "node/4560171195"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4576562692",
        "amenity": "place_of_worship",
        "name:en": "Balmikeshwor Jotirlinga"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.482354,
          27.693249
        ]
      },
      "id": "node/4576562692"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4576612890",
        "amenity": "place_of_worship",
        "name:en": "Lokeshwor Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4607798,
          27.6949635
        ]
      },
      "id": "node/4576612890"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4590558910",
        "amenity": "place_of_worship",
        "name:en": "Shree Santoshimata Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4667328,
          27.6972178
        ]
      },
      "id": "node/4590558910"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4713210889",
        "amenity": "place_of_worship",
        "name:en": "Shree Radhakrishna Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4803236,
          27.686439
        ]
      },
      "id": "node/4713210889"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4713210989",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4735823,
          27.686718
        ]
      },
      "id": "node/4713210989"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4765999654",
        "amenity": "place_of_worship",
        "name": "Shiv Ling"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4902861,
          27.6668011
        ]
      },
      "id": "node/4765999654"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4849852221",
        "amenity": "place_of_worship",
        "name:en": "Jageshwor Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4737932,
          27.7009358
        ]
      },
      "id": "node/4849852221"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5287388021",
        "amenity": "place_of_worship",
        "name:en": "Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4005983,
          27.6894224
        ]
      },
      "id": "node/5287388021"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6323244285",
        "amenity": "place_of_worship",
        "name:en": "Shiva Mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4049238,
          27.7049345
        ]
      },
      "id": "node/6323244285"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499238772",
        "amenity": "place_of_worship",
        "name": "Shree Champakpur Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4297837,
          27.7162884
        ]
      },
      "id": "node/6499238772"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499243431",
        "amenity": "place_of_worship",
        "name": "Pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4293389,
          27.7164231
        ]
      },
      "id": "node/6499243431"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499243432",
        "name": "Changu Museum",
        "tourism": "museum"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4292412,
          27.7165172
        ]
      },
      "id": "node/6499243432"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499299166",
        "amenity": "place_of_worship",
        "name": "Paati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4283486,
          27.7164378
        ]
      },
      "id": "node/6499299166"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499299167",
        "amenity": "place_of_worship",
        "name": "Changunarayan Tol Sudhar Samiti, Balambu Paati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4285075,
          27.7164187
        ]
      },
      "id": "node/6499299167"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6499299168",
        "amenity": "place_of_worship",
        "name": "Balambu Pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4285974,
          27.7164115
        ]
      },
      "id": "node/6499299168"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501663543",
        "amenity": "place_of_worship",
        "name": "Kilshwor Mahadev"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278407,
          27.716319
        ]
      },
      "id": "node/6501663543"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501663544",
        "amenity": "place_of_worship",
        "name": "Shiv Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.427897,
          27.7162741
        ]
      },
      "id": "node/6501663544"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501663545",
        "amenity": "place_of_worship",
        "name": "Vishnu Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4278136,
          27.716287
        ]
      },
      "id": "node/6501663545"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6501755123",
        "amenity": "place_of_worship",
        "name": "Purba Bhadel Kul Devata"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4268631,
          27.7158285
        ]
      },
      "id": "node/6501755123"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6502071468",
        "amenity": "place_of_worship",
        "name": "Bhairav Pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4274492,
          27.7161861
        ]
      },
      "id": "node/6502071468"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6955722189",
        "amenity": "place_of_worship",
        "name": "Chatrapal Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4233316,
          27.6972539
        ]
      },
      "id": "node/6955722189"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6955722198",
        "amenity": "place_of_worship",
        "name": "Krishna Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4203707,
          27.6982888
        ]
      },
      "id": "node/6955722198"
    }
  ]
}
  },
  'madhyapur_thimi': {
    'school': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/2287639330",
          "properties": {
            "amenity": "school",
            "name": "Vidyadayini School",
            "id": "node/2287639330"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3765911,
              27.673463
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/3136185727",
          "properties": {
            "amenity": "school",
            "name": "bright vision education center",
            "id": "node/3136185727"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3903629,
              27.6901282
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4373340694",
          "properties": {
            "amenity": "school",
            "name": "Global pathshala",
            "opening_hours": "Su-Fr 08:30-16:30",
            "phone": "016638533",
            "id": "node/4373340694"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3686723,
              27.6725237
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5549773260",
          "properties": {
            "addr:country": "NP",
            "addr:place": "Jalkhu",
            "addr:street": "Jalkhu Marga",
            "amenity": "school",
            "name": "Pranodaya Primary School",
            "opening_hours": "10:00-16:00",
            "operator": "Public",
            "id": "node/5549773260"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3882594,
              27.6793709
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6064240605",
          "properties": {
            "amenity": "school",
            "name": "Sano Thimi Technical chool",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/6064240605"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3725551,
              27.6808686
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6419160386",
          "properties": {
            "addr:postcode": "44811",
            "addr:street": "Gankhu _ bode",
            "amenity": "school",
            "name:en": "Everest Public Academy",
            "opening_hours": "Su-Fr 10:00-17:00",
            "id": "node/6419160386"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.396747,
              27.6886141
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/7551860486",
          "properties": {
            "addr:street": "Shyama Shyama Dham",
            "amenity": "school",
            "email": "gomapokhrel20@gmail.com",
            "name:en": "IRIS florets Bhaktapur Montessori",
            "opening_hours": "Su-Fr 09:00-17:00",
            "phone": "016636637",
            "id": "node/7551860486"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.398821,
              27.6753435
            ]
          }
        }
      ]
    },
    'bank': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/2245133836",
          "properties": {
            "amenity": "bank",
            "atm": "yes",
            "name": "Himalayan Bank Pvt. Ltd",
            "id": "node/2245133836"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3633994,
              27.6749154
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/2245139975",
          "properties": {
            "addr:city": "Madyapur Thimi 3",
            "addr:place": "Gatthaghar",
            "amenity": "bank",
            "atm": "yes",
            "name": "Prime Bank Pvt. Ltd.",
            "opening_hours": "09:00-17:00",
            "wheelchair": "no",
            "id": "node/2245139975"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3749125,
              27.6741109
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/2249148039",
          "properties": {
            "addr:city": "Madyapur Thimi 3",
            "addr:street": "Kausaltar",
            "amenity": "bank",
            "atm": "yes",
            "name": "NIC Bank",
            "opening_hours": "10:00 - 15:00",
            "operator": "private",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/2249148039"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3646816,
              27.6747967
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/2249167450",
          "properties": {
            "amenity": "bank",
            "name": "KIST Bank",
            "id": "node/2249167450"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.365199,
              27.6739749
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/2342018466",
          "properties": {
            "amenity": "bank",
            "atm": "yes",
            "name": "Royal Merchant Banking and Finance Ltd.",
            "id": "node/2342018466"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3608362,
              27.6744741
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/3136185728",
          "properties": {
            "amenity": "bank",
            "name": "kalash saving and credit cooperative society limited",
            "id": "node/3136185728"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3909259,
              27.6907345
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/3803426949",
          "properties": {
            "amenity": "bank",
            "name": "ace development bank",
            "id": "node/3803426949"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3648482,
              27.6742278
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4235760489",
          "properties": {
            "amenity": "bank",
            "name": "Nepal Banijya Bank",
            "id": "node/4235760489"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3879197,
              27.6831711
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4243030035",
          "properties": {
            "addr:city": "Madyapur Thimi 3",
            "addr:street": "Kausaltar",
            "amenity": "bank",
            "name": "prabhu bank",
            "opening_hours": "9:00 - 15:00",
            "operator": "private",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/4243030035"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3651955,
              27.674693
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4243040929",
          "properties": {
            "addr:street": "Shankhadar Chowk",
            "amenity": "bank",
            "name": "Prabhu Bank",
            "id": "node/4243040929"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3854613,
              27.6735172
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4264060430",
          "properties": {
            "amenity": "bank",
            "name": "Apex Development bank Ltd.",
            "id": "node/4264060430"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3605678,
              27.6745055
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4275939289",
          "properties": {
            "amenity": "bank",
            "name": "Machhapuchre bank",
            "id": "node/4275939289"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3825788,
              27.6731536
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4394344089",
          "properties": {
            "amenity": "bank",
            "name": "Araniko Co-operative",
            "opening_hours": "Su-Fr 10:00-17:00",
            "id": "node/4394344089"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3730815,
              27.6729536
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4394927094",
          "properties": {
            "amenity": "bank",
            "name:en": "Araniko Co-operative",
            "opening_hours": "Su-Fr 10:00-17:00",
            "id": "node/4394927094"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3730774,
              27.6729401
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4417866492",
          "properties": {
            "amenity": "bank",
            "name:en": "Araniko Co-operative",
            "id": "node/4417866492"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3730623,
              27.6729396
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4432060781",
          "properties": {
            "amenity": "bank",
            "atm": "yes",
            "name": "Thibodin Bachat Tatha Rin Sahakari Sanstha",
            "phone": "016639542",
            "id": "node/4432060781"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3887172,
              27.6898086
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4497805093",
          "properties": {
            "addr:postcode": "44811",
            "addr:street": "Madhyapur Thimi - 7, Bahakha Bazar",
            "amenity": "bank",
            "name:en": "Citizens Bank International Limited",
            "opening_hours": "Su-Fr 10:00-05:00",
            "phone": "016636535",
            "id": "node/4497805093"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3879323,
              27.6831307
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4559353392",
          "properties": {
            "addr:city": "Madhyapur Thimi Municipality",
            "addr:place": "Bahakha bazar - 6",
            "addr:postcode": "44811",
            "addr:street": "Bode marga",
            "amenity": "bank",
            "name": "Nepal Credit & Commercial Ltd",
            "opening_hours": "Su-Fr 10:00-16:00",
            "operator": "Private",
            "id": "node/4559353392"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3874924,
              27.6834748
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4559353790",
          "properties": {
            "addr:city": "Madhyapur Thimi Municipality",
            "addr:place": "Bahakha bazar - 6",
            "addr:postcode": "44811",
            "addr:street": "Bode marga",
            "amenity": "bank",
            "name:en": "Mega Bank Limited",
            "opening_hours": "Su-Fr 10:00-16:00",
            "operator": "Private",
            "id": "node/4559353790"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3873534,
              27.683341
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4559360892",
          "properties": {
            "addr:postcode": "44811",
            "addr:street": "Madhyapur Thimi - 7, Hulak Road",
            "amenity": "bank",
            "name:en": "Swastik saving & Credit Co-operative Limited",
            "opening_hours": "Su-Fr 10:00-15:00",
            "phone": "016633067",
            "id": "node/4559360892"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3901322,
              27.6835816
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4728706590",
          "properties": {
            "amenity": "bank",
            "name:en": "Nepal Bank",
            "id": "node/4728706590"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3865489,
              27.6731341
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4820611885",
          "properties": {
            "addr:street": "Araniko Raj Marga",
            "amenity": "bank",
            "name": "Himalayan Bank Limited",
            "name:en": "Himalayan Bank",
            "phone": "01-4250201",
            "website": "https://www.himalayanbank.com",
            "wheelchair": "no",
            "id": "node/4820611885"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3693288,
              27.6745583
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5267586121",
          "properties": {
            "amenity": "bank",
            "name": "Nepal investment bank",
            "name:en": "Nepal investment bank",
            "id": "node/5267586121"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3648344,
              27.6742201
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5687407621",
          "properties": {
            "amenity": "bank",
            "name:en": "Siddhartha Bank",
            "wheelchair": "no",
            "id": "node/5687407621"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3730439,
              27.6741436
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6064240609",
          "properties": {
            "amenity": "bank",
            "name": "Nabil Bank Kaushaltar",
            "wheelchair": "no",
            "id": "node/6064240609"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3634122,
              27.674311
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6064240610",
          "properties": {
            "amenity": "bank",
            "name": "Nabil Bank Limited",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/6064240610"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3644375,
              27.6742593
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6064240611",
          "properties": {
            "amenity": "bank",
            "name": "Laxmi Bank Limited",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/6064240611"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3686594,
              27.6745077
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6064309355",
          "properties": {
            "amenity": "bank",
            "name": "Siddharth Bank Limited",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/6064309355"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3727947,
              27.6742337
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6064309357",
          "properties": {
            "amenity": "bank",
            "name": "Prime Bank Limited",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/6064309357"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3747215,
              27.6735744
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065286049",
          "properties": {
            "amenity": "bank",
            "name": "Sumeru saving and credit cooperative ltd",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/6065286049"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3759,
              27.6728516
            ]
          }
        }
      ]
    },
    'hospital': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4243043791",
          "properties": {
            "amenity": "hospital",
            "name": "Madhyapur Hospital",
            "id": "node/4243043791"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3879984,
              27.6725806
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6064309358",
          "properties": {
            "amenity": "hospital",
            "healthcare": "hospital",
            "name": "Nagarik Community Hospital",
            "toilets:wheelchair": "limited",
            "wheelchair": "yes",
            "id": "node/6064309358"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3750363,
              27.6742186
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065425312",
          "properties": {
            "amenity": "hospital",
            "healthcare": "hospital",
            "name": "Madhyapur Hospital Thimi",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/6065425312"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3881738,
              27.6722536
            ]
          }
        }
      ]
    },
    'government': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/2176870537",
          "properties": {
            "name": "Curriculum Development Center / editing and publishing",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/2176870537"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3731796,
              27.6851608
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/2176967325",
          "properties": {
            "name": "The Office of Controller of Examinations (OCE)",
            "office": "government",
            "operator": "Ministry of Education",
            "id": "node/2176967325"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3730921,
              27.6839377
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4235736994",
          "properties": {
            "name": "Madhyapur Thimi Municipality",
            "office": "government",
            "id": "node/4235736994"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3896965,
              27.6837543
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4243016526",
          "properties": {
            "name": "madhyapur thimi 15",
            "office": "government",
            "opening_hours": "10:00 - 17:00",
            "id": "node/4243016526"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3656923,
              27.6747648
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4243043013",
          "properties": {
            "name": "NEA",
            "office": "government",
            "id": "node/4243043013"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3821266,
              27.6752397
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4304550691",
          "properties": {
            "name": "Teacher Service Commotion",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/4304550691"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3734759,
              27.6860151
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4304621291",
          "properties": {
            "name": "Nepal Center For Educational Development Hostel",
            "office": "government",
            "id": "node/4304621291"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3719519,
              27.6871596
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4304645990",
          "properties": {
            "name": "NCED branch",
            "office": "government",
            "id": "node/4304645990"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3726385,
              27.6834589
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4304647489",
          "properties": {
            "name": "Nepal Center For Educational Development",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/4304647489"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3717971,
              27.6864247
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4341039697",
          "properties": {
            "name": "ERO Office",
            "office": "government",
            "id": "node/4341039697"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3724352,
              27.6861099
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4341062892",
          "properties": {
            "name": "CDC",
            "office": "government",
            "id": "node/4341062892"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3730207,
              27.6860129
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4396457696",
          "properties": {
            "name": "Office of Controller of Examinations (OCE)",
            "office": "government",
            "id": "node/4396457696"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3768159,
              27.6808675
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4476143994",
          "properties": {
            "addr:city": "Madhyapur Thimi Municipality",
            "addr:place": "Swanga Pukhu - 6",
            "addr:street": "Swanga Pukhu Marga",
            "amenity": "Public office",
            "name:en": "Madhyapur Thimi ward 6 Municipality Office",
            "office": "government",
            "opening_hours": "Su-Fr 10:00-04:00",
            "id": "node/4476143994"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3866649,
              27.6818853
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4486629391",
          "properties": {
            "addr:street": "Bode,  Town Planning",
            "name:en": "Agriculture Training Center",
            "office": "government",
            "id": "node/4486629391"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.395864,
              27.6902465
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4563715195",
          "properties": {
            "name:en": "Muktinath Workshop",
            "office": "government",
            "id": "node/4563715195"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3803423,
              27.6732533
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4563726790",
          "properties": {
            "name:en": "B.R. Workshop",
            "office": "government",
            "id": "node/4563726790"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.38051,
              27.6732835
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4563727392",
          "properties": {
            "name:en": "Asia Creation Nepal",
            "office": "government",
            "id": "node/4563727392"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3801131,
              27.6737366
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4598092590",
          "properties": {
            "addr:street": "Lokanthali To Sano Thimi",
            "name:en": "District Forest Office, Bhaktapur",
            "office": "government",
            "opening_hours": "Su-Fr 10:00-17:00",
            "id": "node/4598092590"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.367829,
              27.6836466
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6058283671",
          "properties": {
            "name": "National Youth Council",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/6058283671"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3725245,
              27.6823058
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6058283672",
          "properties": {
            "name": "Education Review Office",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "no",
            "id": "node/6058283672"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.372166,
              27.6856818
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6058287188",
          "properties": {
            "name": "Teacher Service Commission",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "limited",
            "id": "node/6058287188"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3730715,
              27.685537
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065420353",
          "properties": {
            "name": "Nepal Telecom",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/6065420353"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3758873,
              27.6725285
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6375476469",
          "properties": {
            "addr:city": "Madhypur Thmi",
            "addr:postcode": "977",
            "addr:street": "Purano Thimi- Naya Thimi",
            "height": "10",
            "name": "Madhyapur thimi Ward 04",
            "office": "government",
            "id": "node/6375476469"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3852656,
              27.6759823
            ]
          }
        }
      ]
    },
    'touristic_religious': {
  "type": "FeatureCollection",
  "generator": "overpass-ide",
  "copyright": "The data included in this document is from www.openstreetmap.org. The data is made available under ODbL.",
  "timestamp": "2021-01-11T04:28:02Z",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1945526719",
        "addr:city": "Thimi",
        "addr:housenumber": "14",
        "addr:street": "Balkumari",
        "amenity": "place_of_worship",
        "name": "Balkumari Temple;भैरब मन्दिर",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.38537,
          27.6759307
        ]
      },
      "id": "node/1945526719"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/1945526732",
        "addr:city": "Madhyapur Thimi",
        "addr:place": "Siddhikali mandir parisad",
        "addr:street": "Siddhikali mandir marga",
        "amenity": "place_of_worship",
        "name": "Siddhikali Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3830995,
          27.680756
        ]
      },
      "id": "node/1945526732"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2183358246",
        "amenity": "place_of_worship",
        "designation": "Bapa Hiti",
        "name": "Bishweshwar बिश्वेस्वोर महादेव",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3876573,
          27.6747729
        ]
      },
      "id": "node/2183358246"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2245137965",
        "addr:city": "Madyapur Thimi 3",
        "addr:street": "Kausaltar",
        "amenity": "place_of_worship",
        "name": "Bhairab than",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3661352,
          27.6748488
        ]
      },
      "id": "node/2245137965"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2249176240",
        "amenity": "place_of_worship",
        "name": "Nilbarahi Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3963984,
          27.6954342
        ]
      },
      "id": "node/2249176240"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2318106936",
        "amenity": "place_of_worship",
        "name": "Devishowari Tempel",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3597878,
          27.6743831
        ]
      },
      "id": "node/2318106936"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2824165215",
        "addr:city": "Thimi",
        "addr:street": "Ajima Nani",
        "amenity": "place_of_worship",
        "name": "अजिमा मन्दिर",
        "note": "Anapurna Ajima Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3832455,
          27.6764898
        ]
      },
      "id": "node/2824165215"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2824216265",
        "addr:city": "Thimi",
        "amenity": "place_of_worship",
        "name": "Bishnu Bir Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3839927,
          27.6762287
        ]
      },
      "id": "node/2824216265"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2824301701",
        "amenity": "place_of_worship",
        "name": "लोकेश्वोर मन्दिर",
        "religion": "buddhist;hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3856568,
          27.6763795
        ]
      },
      "id": "node/2824301701"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3072782147",
        "amenity": "place_of_worship",
        "name": "Neel-Barahi Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3889836,
          27.6918577
        ]
      },
      "id": "node/3072782147"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3072784499",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3883383,
          27.6902908
        ]
      },
      "id": "node/3072784499"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3072784500",
        "amenity": "place_of_worship",
        "name": "Pacho Ganesh",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3868534,
          27.6917808
        ]
      },
      "id": "node/3072784500"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212840",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3887193,
          27.6909653
        ]
      },
      "id": "node/3081212840"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212841",
        "amenity": "place_of_worship",
        "name": "Mahadev Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3887294,
          27.6909601
        ]
      },
      "id": "node/3081212841"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212842",
        "amenity": "place_of_worship",
        "name": "Narayan Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3888303,
          27.6908827
        ]
      },
      "id": "node/3081212842"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212875",
        "amenity": "place_of_worship",
        "name": "peepal bot",
        "natural": "tree",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3886174,
          27.6902783
        ]
      },
      "id": "node/3081212875"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081212876",
        "amenity": "place_of_worship",
        "name": "pipal bot",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3898665,
          27.6905689
        ]
      },
      "id": "node/3081212876"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3081213061",
        "amenity": "place_of_worship",
        "building": "temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3917126,
          27.6915993
        ]
      },
      "id": "node/3081213061"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3132479368",
        "amenity": "place_of_worship",
        "name": "mahalaxmi mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3881367,
          27.6921884
        ]
      },
      "id": "node/3132479368"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3143339051",
        "amenity": "place_of_worship",
        "name": "Narayan Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3895768,
          27.6918788
        ]
      },
      "id": "node/3143339051"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151907534",
        "amenity": "place_of_worship",
        "name": "Gorakhnath Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3857143,
          27.6916727
        ]
      },
      "id": "node/3151907534"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151907535",
        "amenity": "place_of_worship",
        "name": "Kumari Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3858556,
          27.6919577
        ]
      },
      "id": "node/3151907535"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151911661",
        "amenity": "place_of_worship",
        "name": "Narayan Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3881342,
          27.6913667
        ]
      },
      "id": "node/3151911661"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3151911662",
        "amenity": "place_of_worship",
        "name": "Peepal bot",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.388481,
          27.6923842
        ]
      },
      "id": "node/3151911662"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4133403025",
        "addr:city": "Madhyapur Thimi",
        "addr:street": "Digu Tole",
        "amenity": "place_of_worship",
        "name": "प्रचन्द भैरब मन्दिर",
        "name:en": "Prachanda Bhairav Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3856831,
          27.6791536
        ]
      },
      "id": "node/4133403025"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4133403026",
        "addr:city": "Madhyapur Thimi",
        "addr:street": "Digu Tol",
        "amenity": "place_of_worship",
        "name": "दिगु बाहा",
        "name:en": "Guna Kirti Mahabihar",
        "name:ne": "गुन किर्ति माहाबिर",
        "religion": "buddhist"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3860602,
          27.6795595
        ]
      },
      "id": "node/4133403026"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4133418725",
        "addr:city": "Madhyapur Thimi",
        "addr:street": "Dev Tol",
        "amenity": "place_of_worship",
        "name": "Bandevi Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3859859,
          27.6741947
        ]
      },
      "id": "node/4133418725"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4235575290",
        "addr:street": "Wamune",
        "amenity": "place_of_worship",
        "name": "Wamune Ganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3866944,
          27.6757803
        ]
      },
      "id": "node/4235575290"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4235620292",
        "amenity": "place_of_worship",
        "name": "Bisheswor Mahadev",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3874632,
          27.6747647
        ]
      },
      "id": "node/4235620292"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4243030034",
        "amenity": "place_of_worship",
        "name:en": "Sankhadhar sakhwa"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3853146,
          27.6736379
        ]
      },
      "id": "node/4243030034"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4243043010",
        "amenity": "place_of_worship",
        "name": "Bandevi"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3858243,
          27.6743477
        ]
      },
      "id": "node/4243043010"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4264053777",
        "amenity": "place_of_worship",
        "name": "bhairav temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3588987,
          27.6716161
        ]
      },
      "id": "node/4264053777"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295561600",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3845059,
          27.6850169
        ]
      },
      "id": "node/4295561600"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295562614",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3843232,
          27.68523
        ]
      },
      "id": "node/4295562614"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295590488",
        "amenity": "place_of_worship",
        "name": "Nagadesh siddhi ganesh temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3843849,
          27.6842082
        ]
      },
      "id": "node/4295590488"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4295592848",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3845417,
          27.6849901
        ]
      },
      "id": "node/4295592848"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4313008926",
        "addr:city": "Madhyapur Thimi Municipality",
        "addr:place": "Bahakha bazar - 6",
        "addr:street": "Madhyapur thimi marga",
        "amenity": "place_of_worship",
        "name": "bhimshen mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3873016,
          27.6831377
        ]
      },
      "id": "node/4313008926"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4313036674",
        "amenity": "place_of_worship",
        "name": "krishna temple",
        "religion": "shinto"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.381905,
          27.6894085
        ]
      },
      "id": "node/4313036674"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4342388489",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.387281,
          27.6826939
        ]
      },
      "id": "node/4342388489"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4360771393",
        "amenity": "place_of_worship",
        "name": "Mahadev Sthan",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.386169,
          27.6831087
        ]
      },
      "id": "node/4360771393"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4365880992",
        "amenity": "place_of_worship",
        "name": "Sileshwor Mahadev (Bisantaki Tole) Nagadesh",
        "name:en": "Sileshwor Mahadev (Bisantaki Tole) Nagadesh",
        "name:ne": "सिलेस्वर महादेव,  बिसन्तकी टोल, नगदेश",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3814433,
          27.6874613
        ]
      },
      "id": "node/4365880992"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4432030050",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.380926,
          27.6893476
        ]
      },
      "id": "node/4432030050"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4465721390",
        "amenity": "place_of_worship",
        "name:en": "Shyam Shyam Sadhana Sadan"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4000653,
          27.6747958
        ]
      },
      "id": "node/4465721390"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4471169590",
        "addr:street": "Purano Thimi- Naya Thimi",
        "amenity": "place_of_worship",
        "name:en": "Purbasthit Mahavihar ( Jiswanbahal )"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3865708,
          27.6816894
        ]
      },
      "id": "node/4471169590"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4472634991",
        "addr:street": "bappa marg , Bishweshwor nagar",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3875529,
          27.6747591
        ]
      },
      "id": "node/4472634991"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4476159389",
        "addr:city": "Madhyapur Thimi Municipality",
        "addr:place": "Swaga Pukhu - 6",
        "addr:street": "Swanga Pukhu Marga",
        "amenity": "place_of_worship",
        "historic": "monument",
        "name": "Vidhyaganesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3865107,
          27.6817928
        ]
      },
      "id": "node/4476159389"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4693748200",
        "addr:street": "Siwa Tole",
        "amenity": "place_of_worship",
        "name:en": "Mahadev Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3864642,
          27.6775685
        ]
      },
      "id": "node/4693748200"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4693751297",
        "addr:street": "Lakayu",
        "amenity": "place_of_worship",
        "name:en": "Bhairav"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3857063,
          27.6773156
        ]
      },
      "id": "node/4693751297"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4693753093",
        "addr:street": "Siwa Tole",
        "amenity": "place_of_worship",
        "name:en": "Shiva Ganesh temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3864692,
          27.6775498
        ]
      },
      "id": "node/4693753093"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275131021",
        "amenity": "place_of_worship",
        "name:en": "Bhuichampa Devi Temple Gankhu",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3982407,
          27.6849708
        ]
      },
      "id": "node/5275131021"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275144823",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3947228,
          27.6830894
        ]
      },
      "id": "node/5275144823"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275169921",
        "amenity": "place_of_worship",
        "name:en": "Akash Devi Temple Gankhu Dharmapur",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3970241,
          27.6849326
        ]
      },
      "id": "node/5275169921"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5275243025",
        "addr:postcode": "+9771",
        "addr:street": "gankhu",
        "amenity": "place_of_worship",
        "name:en": "Bhuichapa Devi Temple Gankhu Dharmapur",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3982584,
          27.6847661
        ]
      },
      "id": "node/5275243025"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5276269721",
        "amenity": "place_of_worship",
        "name:en": "Ganesh temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.396652,
          27.6853474
        ]
      },
      "id": "node/5276269721"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5285663722",
        "amenity": "place_of_worship",
        "name:en": "God Shiva Temple Dharmapur",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3989033,
          27.6881181
        ]
      },
      "id": "node/5285663722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5285665922",
        "amenity": "place_of_worship",
        "name:en": "Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3985877,
          27.6869437
        ]
      },
      "id": "node/5285665922"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5362350119",
        "addr:place": "Madyapur Thimi 9",
        "addr:street": "Nilbarahi Road",
        "amenity": "place_of_worship",
        "name": "Nilkanthesor Mahadev",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3935179,
          27.6920142
        ]
      },
      "id": "node/5362350119"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5388482124",
        "addr:postcode": "977",
        "addr:street": "road",
        "amenity": "place_of_worship",
        "name:en": "Ganta Ganesh Temple"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3847537,
          27.6752744
        ]
      },
      "id": "node/5388482124"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5532464321",
        "addr:street": "Nagadesh Marg",
        "amenity": "place_of_worship",
        "name:en": "Narayan Sthan, Nagadesh"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3871023,
          27.6849946
        ]
      },
      "id": "node/5532464321"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5856222132",
        "amenity": "place_of_worship",
        "denomination": "hindu",
        "name": "Balkumari Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3853115,
          27.6758838
        ]
      },
      "id": "node/5856222132"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6313577288",
        "addr:street": "Kaushaltar-Balkot",
        "amenity": "place_of_worship",
        "email": "eziolayra@gmail.com",
        "name:en": "Ganesh Than(swarswoti mandir)"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3633515,
          27.67398
        ]
      },
      "id": "node/6313577288"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6528690586",
        "amenity": "place_of_worship",
        "name": "Ganesthan",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3634596,
          27.673937
        ]
      },
      "id": "node/6528690586"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6694544520",
        "amenity": "place_of_worship",
        "name": "Sisakoti Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3548083,
          27.6687892
        ]
      },
      "id": "node/6694544520"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6694544521",
        "amenity": "place_of_worship",
        "name": "Hanuman Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3525861,
          27.6682107
        ]
      },
      "id": "node/6694544521"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7688040704",
        "amenity": "place_of_worship",
        "name": "Ganesh mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3620737,
          27.6740023
        ]
      },
      "id": "node/7688040704"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7798016813",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3669954,
          27.680606
        ]
      },
      "id": "node/7798016813"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7823639985",
        "amenity": "place_of_worship",
        "name:en": "Gankhu pipal dev",
        "name:hi": "गाँखु पिपल देब"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3984437,
          27.6800763
        ]
      },
      "id": "node/7823639985"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/7823670485",
        "addr:postcode": "44811",
        "addr:street": "Gankhu marg",
        "amenity": "place_of_worship",
        "name:en": "Gankhu Mahadev mandir",
        "name:hi": "गाँखु महादेब मन्दिर"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3948072,
          27.6885393
        ]
      },
      "id": "node/7823670485"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8049295009",
        "amenity": "place_of_worship",
        "name": "Shiva Statue"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3660189,
          27.6731116
        ]
      },
      "id": "node/8049295009"
    }
  ]
}
  },
  'suryabinayak': {
    'school': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4742463425",
          "properties": {
            "amenity": "school",
            "name": "Shree Kulamaya Bhagwati School",
            "id": "node/4742463425"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3932983,
              27.637829
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5270088722",
          "properties": {
            "addr:street": "Chonga Ganesh Road",
            "amenity": "school",
            "name:en": "Unique international English school",
            "id": "node/5270088722"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4040224,
              27.6683218
            ]
          }
        }
      ]
    },
    'bank': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/2477486808",
          "properties": {
            "amenity": "bank",
            "name": "Rastriya Banijya",
            "id": "node/2477486808"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4277665,
              27.6651675
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4529393889",
          "properties": {
            "addr:housenumber": "100",
            "addr:postcode": "44800",
            "addr:street": "Arniko Raj Marga",
            "amenity": "bank",
            "name:en": "Gurkhas Finance",
            "id": "node/4529393889"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4263609,
              27.6653502
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4936281426",
          "properties": {
            "addr:street": "Bhaktapur",
            "amenity": "bank",
            "name:en": "Everest Bank",
            "id": "node/4936281426"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4231039,
              27.6657054
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/5796473656",
          "properties": {
            "addr:postcode": "+977",
            "addr:street": "Ghalate",
            "amenity": "bank",
            "email": "katunjecooperativeltd@gmail.com",
            "name:en": "Katunje Sahakari Ltd",
            "operator": "Katunje Sahakari Ltd",
            "phone": "015092214",
            "id": "node/5796473656"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4221984,
              27.6656883
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065420352",
          "properties": {
            "amenity": "bank",
            "name": "Nepal Investment Bank Limited",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/6065420352"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.3653105,
              27.6724913
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6789566385",
          "properties": {
            "addr:street": "Binayak Marga",
            "amenity": "bank",
            "name:en": "Himalayan Saving & Credit Co Operative",
            "opening_hours": "Su-Fr 09:00-18:00",
            "phone": "015092803",
            "id": "node/6789566385"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4258088,
              27.664277
            ]
          }
        }
      ]
    },
    'hospital': {
      "type": "FeatureCollection",
      "features": []
    },
    'government': {
      "type": "FeatureCollection",
      "features": [{
          "type": "Feature",
          "id": "node/4617878292",
          "properties": {
            "addr:postcode": "0977-016",
            "addr:street": "katunje bhaktapur",
            "name:en": "Department of roads katunje",
            "office": "government",
            "id": "node/4617878292"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4039791,
              27.6675636
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/4826560421",
          "properties": {
            "name:en": "Department of transportation management ( Driving license)",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/4826560421"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4364766,
              27.6664342
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6065482889",
          "properties": {
            "name": "Inland Revenue Department (Tax office Bhaktapur )",
            "office": "government",
            "toilets:wheelchair": "no",
            "wheelchair": "yes",
            "id": "node/6065482889"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4357643,
              27.6660684
            ]
          }
        },
        {
          "type": "Feature",
          "id": "node/6397585185",
          "properties": {
            "name:en": "sipadol woda karyalaya",
            "office": "government",
            "id": "node/6397585185"
          },
          "geometry": {
            "type": "Point",
            "coordinates": [
              85.4329768,
              27.6436557
            ]
          }
        }
      ]
    },
    'touristic_religious': {
  "type": "FeatureCollection",
  "generator": "overpass-ide",
  "copyright": "The data included in this document is from www.openstreetmap.org. The data is made available under ODbL.",
  "timestamp": "2021-01-11T04:19:03Z",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "@id": "node/990950522",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4467281,
          27.6473432
        ]
      },
      "id": "node/990950522"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/2249178847",
        "addr:housename": "Dadhikot",
        "amenity": "place_of_worship",
        "name": "Dakshin Barahi Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3859703,
          27.6681336
        ]
      },
      "id": "node/2249178847"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3039065476",
        "amenity": "place_of_worship",
        "denomination": "Ganesh",
        "name": "Suryabinayak Temple",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4234873,
          27.6563094
        ]
      },
      "id": "node/3039065476"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3157663313",
        "amenity": "place_of_worship",
        "name": "krishna mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4012316,
          27.6630837
        ]
      },
      "id": "node/3157663313"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/3157670629",
        "amenity": "place_of_worship",
        "name": "Subarneshwor Mahadev",
        "name:ne": "सुबर्णेश्वोर महादेव",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4088008,
          27.6593164
        ]
      },
      "id": "node/3157670629"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4533150690",
        "amenity": "place_of_worship",
        "name": "Somlingeshwar Mahadev",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3857214,
          27.648814
        ]
      },
      "id": "node/4533150690"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4605332689",
        "amenity": "place_of_worship",
        "name:en": "Subarneshwor"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4143071,
          27.6625698
        ]
      },
      "id": "node/4605332689"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4624545490",
        "amenity": "place_of_worship"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3866389,
          27.6575655
        ]
      },
      "id": "node/4624545490"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4643556590",
        "addr:street": "Balkot-Biruwa Road",
        "amenity": "place_of_worship",
        "name:en": "Bindhabashini"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.394351,
          27.6381491
        ]
      },
      "id": "node/4643556590"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4940187723",
        "amenity": "place_of_worship",
        "name:en": "Ganesh Temple",
        "name:hi": "Ganesh Than"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.3649208,
          27.669708
        ]
      },
      "id": "node/4940187723"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/4945182722",
        "amenity": "place_of_worship",
        "name:en": "Harihardham Balkot"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.375991,
          27.6604541
        ]
      },
      "id": "node/4945182722"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5032163221",
        "addr:street": "Arniko Raj Marga",
        "amenity": "place_of_worship",
        "name:en": "Latarambeshwor"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4838529,
          27.6469049
        ]
      },
      "id": "node/5032163221"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/5519977554",
        "amenity": "place_of_worship",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4754319,
          27.6435529
        ]
      },
      "id": "node/5519977554"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6081068390",
        "amenity": "place_of_worship",
        "name:en": "krishna mandir kumari pati"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.436086,
          27.6519095
        ]
      },
      "id": "node/6081068390"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6085423487",
        "amenity": "place_of_worship",
        "name:en": "Katunje Krishna Pranami Mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4158048,
          27.6626723
        ]
      },
      "id": "node/6085423487"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6296924387",
        "amenity": "place_of_worship",
        "name:en": "Sipadol Manakamana Mai",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4360603,
          27.645889
        ]
      },
      "id": "node/6296924387"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/6397585285",
        "amenity": "place_of_worship",
        "name:en": "Doleshor mandir"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4384773,
          27.6389239
        ]
      },
      "id": "node/6397585285"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8080174158",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4092237,
          27.6488234
        ]
      },
      "id": "node/8080174158"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8080174159",
        "amenity": "place_of_worship",
        "name": "Radha Krishna Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4091774,
          27.6476548
        ]
      },
      "id": "node/8080174159"
    },
    {
      "type": "Feature",
      "properties": {
        "@id": "node/8080189726",
        "amenity": "place_of_worship",
        "name": "Ganesh Mandir",
        "religion": "hindu"
      },
      "geometry": {
        "type": "Point",
        "coordinates": [
          85.4051003,
          27.6503187
        ]
      },
      "id": "node/8080189726"
    }
  ]
},
  },
}
